const TONES = {
  gray: 'bg-gray-100 text-gray-700',
  amber: 'bg-amber-100 text-amber-800',
  green: 'bg-green-100 text-green-800',
  red: 'bg-red-100 text-red-700',
  slate: 'bg-slate-200 text-slate-700',
  purple: 'bg-purple-100 text-purple-800',
};

// Status → tone, per the design system's status badge colors.
export const STATUS_TONES = {
  registered: 'gray',
  in_progress: 'amber',
  hired: 'green',
  rejected: 'red',
  withdrawn: 'slate',
  suspended: 'slate',
  hold: 'purple',
  approved: 'green',
  passed: 'green',
  failed: 'red',
  pending: 'gray',
  completed: 'green',
};

export default function Badge({ tone = 'gray', children, className = '' }) {
  return (
    <span
      className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium capitalize ${TONES[tone] || TONES.gray} ${className}`}
    >
      {children}
    </span>
  );
}

export function StatusBadge({ status }) {
  const label = status === 'withdrawn' ? 'backout' : (status || '').replace(/_/g, ' ');
  return <Badge tone={STATUS_TONES[status] || 'gray'}>{label}</Badge>;
}
